"use client";
import { PageLayout } from "@components/shared";
import { ApplyNowBanner, ApplyNowForm } from "@components/views/apply-now";

function ApplyNowPage() {
    return (
        <PageLayout>
            <ApplyNowBanner />
            <ApplyNowForm />
        </PageLayout>
    );
}

export default ApplyNowPage;